import { BankOutlined, TeamOutlined, UserOutlined, CloseOutlined } from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  message,
  Row,
  Select,
  Space,
  Tag,
  Tooltip,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { useCallback, useEffect, useState } from 'react'
import { blue, yellowPrimary } from '../../../../color'
import { AvatarHasName } from '../../../../components/Common/Avatar'
import { DivFlex } from '../../../../components/Common/CellText'
import SelectGroupPopup from '../../../../components/SelectGroupPopup/SelectGroupPopup'
import SelectPeoplePopup from '../../../../components/SelectPeoplePopup/SelectPeoplePopup'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  DATE_FORMAT_LIST,
  INTERNAL_DOCUMENT_INCOMING_STATUS,
} from '../../../../constants'
import authenticationStore from '../../../../stores/authenticationStore'
import { SelectList } from '../../../MissionCreatePage/MissionCreatePageStyled'
import {
  LableItem,
  ModalWrapper,
  TitleModal,
} from './PopupHandleDocumentIncomingStyled'

const { Option } = Select

const PopupHandleDocumentIncoming = props => {
  const {
    internalDocumentStore,
    loadingAnimationStore,
    selectPeopleStore,
    aclStore,
  } = props

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    originDepartmentWithUserList,
    clearSelected,
  } = selectPeopleStore

  const {
    selectedInternalDocumentIncoming,
    userAssignList,
    departmentAssignList,
    groupAssignList,
  } = internalDocumentStore

  const {
    end_date,
    start_date,
    document_status,
    date_issued,
  } = selectedInternalDocumentIncoming

  const {
    isVisiblePopupHandleDocument,
    handleCloseHandleDocument,
    handleCancelHandleDocument,
  } = props

  const [handlerList, setHandlerList] = useState([])
  const [combinerList, setCombinerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [isDataChanged, setIsDataChanged] = useState(false)

  const [valueInput, setValueInput] = useState({
    start_date: null,
    end_date: null,
    document_status: null,
  })

  // Check chọn người dành riêng cho văn bản đến, văn bản đi
  const [isSendType, setIsSendType] = useState(false)
  const [checkCurrentUserAction, setCheckCurrentUserAction] = useState(false)

  const { currentUser } = authenticationStore
  const { aclActionsByUser } = aclStore

  useEffect(() => {
    const targetCodes = new Set([
      ACL_ACTION_TYPE.them_nguoi_INCOMING,
      ACL_ACTION_TYPE.them_nguoi_OUTGOING,
    ])
    const currentAclActions = aclActionsByUser.filter(
      item => targetCodes.has(item.code) && item.status === true
    )
    if (currentAclActions.length === 2) {
      setCheckCurrentUserAction(true)
    }
  }, [aclActionsByUser])

  useEffect(() => {
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setCombinerList([
      ...selectUserData[ASSIGNEE_TYPE.COMBINER],
      ...selectDepartmentData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
    ])
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const handleSubmit = useCallback(async () => {
    const new_items_assign = []
    const remove_items_assign = []
    const listAssignOrigin = [
      ...userAssignList,
      ...departmentAssignList,
      ...groupAssignList,
    ].map(el => ({
      assignee_code: el.assignee_code,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))
    const listAssignAfter = [
      ...followerList,
      ...handlerList,
      ...combinerList,
    ].map(el => ({
      assignee_code: el.id,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))
    listAssignAfter.forEach(assignAfter => {
      if (
        !listAssignOrigin.some(
          assignOrigin =>
            assignOrigin.assignee_code + assignOrigin.permission ===
            assignAfter.assignee_code + assignAfter.permission
        )
      ) {
        new_items_assign.push({
          assignee_code: assignAfter.assignee_code,
          assignee_type: assignAfter.assignee_type,
          permission: assignAfter.permission,
        })
      }
    })
    listAssignOrigin.forEach(assignOrigin => {
      if (
        !listAssignAfter.some(
          assignAfter =>
            assignAfter.assignee_code + assignAfter.permission ===
            assignOrigin.assignee_code + assignOrigin.permission
        )
      ) {
        remove_items_assign.push({
          assignee_code: assignOrigin.assignee_code,
          assignee_type: assignOrigin.assignee_type,
          permission: assignOrigin.permission,
        })
      }
    })
    const dataSubmit = {
      new_items: new_items_assign,
      remove_items: remove_items_assign,
      start_date: valueInput.start_date,
      end_date: valueInput.end_date,
      document_status: valueInput.document_status,
      is_xlvb:
        currentUser?.company?.code === 'CPN001' &&
        currentUser?.position?.name === 'Văn thư'
          ? 'VT'
          : null,
    }
    loadingAnimationStore.showSpinner(true)
    try {
      await internalDocumentStore.updateAssignees(
        selectedInternalDocumentIncoming.code,
        dataSubmit
      )
      await internalDocumentStore.getInternalDocumentIncomingById(
        selectedInternalDocumentIncoming.code
      )
      handleCloseHandleDocument()
      message.success('Xử lý văn bản thành công!')
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }, [
    combinerList,
    departmentAssignList,
    followerList,
    groupAssignList,
    handlerList,
    internalDocumentStore,
    loadingAnimationStore,
    selectedInternalDocumentIncoming,
    userAssignList,
    valueInput,
  ])

  useEffect(() => {
    if (!isVisiblePopupHandleDocument) return

    if (
      selectUserData[ASSIGNEE_TYPE.COMBINER].length === 0 &&
      selectUserData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectUserData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectUserData(
        selectPeopleStore.convertSelectDataObj(userAssignList)
      )
    }

    if (
      selectDepartmentData[ASSIGNEE_TYPE.COMBINER].length === 0 &&
      selectDepartmentData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectDepartmentData(
        selectPeopleStore.convertSelectDataObj(departmentAssignList)
      )
    }

    if (
      selectGroupData[ASSIGNEE_TYPE.COMBINER].length === 0 &&
      selectGroupData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectGroupData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectGroupData(
        selectPeopleStore.convertSelectDataObj(groupAssignList)
      )
    }

    setValueInput({
      start_date: start_date ? moment(start_date) : null,
      end_date: end_date ? moment(end_date) : null,
      document_status:
        document_status !== INTERNAL_DOCUMENT_INCOMING_STATUS.INPROGRESS
          ? document_status
          : null,
    })
  }, [
    selectedInternalDocumentIncoming,
    isVisiblePopupHandleDocument,
    originDepartmentWithUserList,
  ])

  useEffect(() => {
    const followStatus =
      JSON.stringify(
        followerList.filter(el => el.permission === 'VIEW').map(el => el.id)
      ) ===
      JSON.stringify([
        ...userAssignList
          .filter(el => el.permission === 'VIEW')
          .map(el => el.assignee_code),
        ...departmentAssignList
          .filter(el => el.permission === 'VIEW')
          .map(el => el.assignee_code),
        ...groupAssignList
          .filter(el => el.permission === 'VIEW')
          .map(el => el.assignee_code),
      ])

    const combiStatus =
      JSON.stringify(combinerList.map(el => el.id)) ===
      JSON.stringify([
        ...userAssignList
          .filter(el => el.permission === 'COOR')
          .map(el => el.assignee_code),
        ...departmentAssignList
          .filter(el => el.permission === 'COOR')
          .map(el => el.assignee_code),
        ...groupAssignList
          .filter(el => el.permission === 'COOR')
          .map(el => el.assignee_code),
      ])

    const handlerStatus =
      JSON.stringify(handlerList.map(el => el.id)) ===
      JSON.stringify(
        userAssignList
          .filter(el => el.permission === 'PIC')
          .map(el => el.assignee_code)
      )

    const doc_status =
      valueInput.document_status === document_status ||
      valueInput.document_status === null

    const start_date_status =
      moment(valueInput.start_date).format('YYYY-MM-DD') ===
      moment(start_date).format('YYYY-MM-DD')
    const end_date_status =
      moment(valueInput.end_date).format('YYYY-MM-DD') ===
      moment(end_date).format('YYYY-MM-DD')

    if (
      followStatus === true &&
      combiStatus === true &&
      handlerStatus === true &&
      doc_status === true &&
      start_date_status === true &&
      end_date_status === true
    ) {
      setIsDataChanged(false)
    } else {
      setIsDataChanged(true)
    }
  }, [valueInput, handlerList, combinerList, followerList])

  const disabledEndDate = useCallback(
    endValue => {
      const startValue = valueInput.start_date
      if (!startValue || !endValue) {
        return false
      }
      return endValue.isBefore(startValue, 'day')
    },
    [valueInput]
  )

  return (
    <>
    <ModalWrapper
      wrapClassName="handle-document-modal-custom"
      closable={false}
      footer={null}
      width={900}
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <span style={{ color: '#333', fontSize: 20, fontWeight: 600 }}>Xử lý văn bản</span>
          <Button
            icon={<CloseOutlined />}
            type={'text'}
            onClick={() => {
              handleCancelHandleDocument()
              clearSelected()
            }}
          />
        </div>
      }
      visible={isVisiblePopupHandleDocument}>
      <Row gutter={[24, 24]}>
        <Col span={8}>
          <LableItem style={{ fontWeight: 500 }}>Trạng thái văn bản:</LableItem>
          <Select
            placeholder={'Trạng thái'}
            style={{
              width: '100%',
              height: 40,
              borderRadius: 8,
            }}
            value={valueInput.document_status}
            onChange={value =>
              setValueInput({
                ...valueInput,
                document_status: value,
              })
            }>
            <Option value={INTERNAL_DOCUMENT_INCOMING_STATUS.PENDING}>
              Chưa xử lý
            </Option>
            <Option value={INTERNAL_DOCUMENT_INCOMING_STATUS.COMPLETE}>
              Hoàn thành
            </Option>
          </Select>
        </Col>
        <Col span={8}>
          <LableItem style={{ fontWeight: 500 }}>Ngày bắt đầu:</LableItem>
          <DatePicker
            style={{
              width: '100%',
              height: 40,
              borderRadius: 8,
            }}
            format={DATE_FORMAT_LIST}
            value={valueInput.start_date && moment(valueInput.start_date)}
            onChange={value =>
              setValueInput({
                ...valueInput,
                start_date: value,
              })
            }
          />
        </Col>
        <Col span={8}>
          <LableItem style={{ fontWeight: 500 }}>Ngày kết thúc:</LableItem>
          <DatePicker
            style={{
              width: '100%',
              height: 40,
              borderRadius: 8,
            }}
            format={DATE_FORMAT_LIST}
            value={valueInput.end_date && moment(valueInput.end_date)}
            onChange={value =>
              setValueInput({
                ...valueInput,
                end_date: value,
              })
            }
            disabledDate={disabledEndDate}
          />
        </Col>
        <Col span={8}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <LableItem style={{ fontWeight: 500, marginBottom: 0 }}>Lãnh đạo xử lý:</LableItem>
            <Space>
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  style={{ borderRadius: 8 }}
                  disabled={
                    !checkCurrentUserAction
                      ? handlerList.some(
                          item =>
                            item.create_user ===
                            authenticationStore.currentUser.username
                        )
                        ? false
                        : true
                      : false
                  }
                  icon={
                    <UserOutlined
                      style={{
                        color: blue,
                      }}
                    />
                  }
                  onClick={() => {
                    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.HANDLER)
                    setIsSendType(true)
                  }}
                />
              </Tooltip>
            </Space>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {handlerList.map(el => (
              <Tag
                className={'tag-selected'}
                color={'blue'}
                key={el.id}
                closable
                style={{ margin: 2, borderRadius: 16, padding: '4px 10px', display: 'inline-flex', alignItems: 'center' }}
                onClose={async () => {
                  await selectPeopleStore.setCheckDocument(true)
                  await selectPeopleStore.setCheckCurrentAction(
                    checkCurrentUserAction
                  )
                  selectPeopleStore.handleRemoveSelect(el)
                }}>
                <AvatarHasName
                  imgId={el.image_id}
                  size={22}
                  name={el.full_name}
                  icon={
                    (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                      <BankOutlined />
                    )) ||
                    (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                      <TeamOutlined />
                    ))
                  }
                />
              </Tag>
            ))}
          </div>
        </Col>
        <Col span={8}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <LableItem style={{ fontWeight: 500, marginBottom: 0 }}>Người xử lý:</LableItem>
            <Space>
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  style={{ borderRadius: 8 }}
                  icon={
                    <UserOutlined
                      style={{
                        color: blue,
                      }}
                    />
                  }
                  onClick={() => {
                    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.COMBINER)
                    setIsSendType(true)
                  }}
                />
              </Tooltip>
              <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                <Button
                  style={{ borderRadius: 8 }}
                  icon={<TeamOutlined />}
                  style={{
                    color: yellowPrimary,
                    borderRadius: 8
                  }}
                  onClick={() =>
                    handleOpenSelectGroupPopup(ASSIGNEE_TYPE.COMBINER)
                  }
                />
              </Tooltip>
            </Space>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {combinerList.map(el => (
              <Tag
                className={'tag-selected'}
                color={'blue'}
                key={el.id}
                closable
                style={{ margin: 2, borderRadius: 16, padding: '4px 10px', display: 'inline-flex', alignItems: 'center' }}
                onClose={async () => {
                  await selectPeopleStore.setCheckDocument(true)
                  await selectPeopleStore.setCheckCurrentAction(
                    checkCurrentUserAction
                  )
                  selectPeopleStore.handleRemoveSelect(el)
                }}>
                <AvatarHasName
                  imgId={el.image_id}
                  size={22}
                  name={el.full_name}
                  icon={
                    (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                      <BankOutlined />
                    )) ||
                    (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                      <TeamOutlined />
                    ))
                  }
                />
              </Tag>
            ))}
          </div>
        </Col>
        <Col span={8}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <LableItem style={{ fontWeight: 500, marginBottom: 0 }}>Phối hợp/ Theo dõi:</LableItem>
            <Space>
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  style={{ borderRadius: 8 }}
                  icon={
                    <UserOutlined
                      style={{
                        color: blue,
                      }}
                    />
                  }
                  onClick={() => {
                    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.FOLLOWER)
                    setIsSendType(true)
                  }}
                />
              </Tooltip>
              <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                <Button
                  style={{ borderRadius: 8 }}
                  icon={<TeamOutlined />}
                  style={{
                    color: yellowPrimary,
                    borderRadius: 8
                  }}
                  onClick={() =>
                    handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)
                  }
                />
              </Tooltip>
            </Space>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {followerList.map(el => (
              <Tag
                className={'tag-selected'}
                color={'blue'}
                key={el.id}
                closable
                style={{ margin: 2, borderRadius: 16, padding: '4px 10px', display: 'inline-flex', alignItems: 'center' }}
                onClose={async () => {
                  await selectPeopleStore.setCheckDocument(true)
                  await selectPeopleStore.setCheckCurrentAction(
                    checkCurrentUserAction
                  )
                  selectPeopleStore.handleRemoveSelect(el)
                }}>
                <AvatarHasName
                  imgId={el.image_id}
                  size={22}
                  name={el.full_name}
                  icon={
                    (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                      <BankOutlined />
                    )) ||
                    (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                      <TeamOutlined />
                    ))
                  }
                />
              </Tag>
            ))}
          </div>
        </Col>
      </Row>

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 32, gap: 16 }}>
        <Button
          danger
          style={{ borderRadius: 8, minWidth: 120, height: 40 }}
          onClick={() => {
            handleCancelHandleDocument()
            clearSelected()
          }}>
          Hủy bỏ
        </Button>
        <Button
          type={'primary'}
          style={{ borderRadius: 8, minWidth: 120, height: 40 }}
          onClick={handleSubmit}
          disabled={!isDataChanged}>
          Đồng ý
        </Button>
      </div>
      <SelectPeoplePopup
        onlyOneUser={
          selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.HANDLER
        }
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
        isSendType={isSendType}
        setIsSendType={setIsSendType}
        checkCurrentUserAction={checkCurrentUserAction}
      />
      <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />
    </ModalWrapper>
    <style>{`
      .handle-document-modal-custom .ant-modal-content {
        border-radius: 16px;
        overflow: hidden;
        background-color: #f0f4f8;
      }
      .handle-document-modal-custom .ant-modal-header {
        background-color: #f0f4f8;
        border-bottom: none;
      }
      .handle-document-modal-custom .ant-modal-body {
        background-color: #ffffff;
        margin: 0 16px 16px 16px;
        border-radius: 16px;
        padding: 24px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.05);
      }
      .handle-document-modal-custom .ant-select-selector {
        height: 40px !important;
        align-items: center;
        border-radius: 8px !important;
      }
      .handle-document-modal-custom .ant-tag {
        display: inline-flex;
        align-items: center;
      }
      .handle-document-modal-custom .ant-tag-close-icon {
        margin-left: 4px;
      }
    `}</style>
    </>
  )
}

PopupHandleDocumentIncoming.propTypes = {}

export default inject(
  'internalDocumentStore',
  'loadingAnimationStore',
  'selectPeopleStore',
  'aclStore'
)(observer(PopupHandleDocumentIncoming))
